import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab1 = ({ ischeckboxEnabled, Whole_Number, UOMName }) => {

  return (
    <div>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>

        <div className="col-2">
          <div className={ischeckboxEnabled.Error ? `mb-3 errorborder` : `mb-3`}>

            <Checkbox
              id="ischeckboxEnabled"
              checked={ischeckboxEnabled}
              label="Enabled"
              value={ischeckboxEnabled?.ischeckboxEnabled || false}
              onChange={(val) => ischeckboxEnabled?.setischeckboxEnabled?.(val)}
              disabled={true}
            />

          </div>
        </div>
        <div className="col-3">
          <div className="mb-3">

            <Checkbox
              id="Whole_Number"
              label="Must be Whole Number"
              value={Whole_Number?.Whole_Number || false}
              onChange={(val) => Whole_Number?.setWhole_Number?.(val)}
              disabled={true}
            />
            <p style={{ fontSize: "9px", color: "#00000099", marginLeft: '23px' }}>
              Check this to disallow fractions. (for Nos)
            </p>
          </div>
        </div>
        <div className="col-7">
          <div className="mb-3">
            <Input
              id="UOMName"
              label="UOM Name"
              style={{ height: "30px", border: UOMName.Error ? "1px solid red" : "", }}
              value={UOMName.UOMName}
              onChange={(e) => UOMName.setUOMName(e.target.value)}
              readOnly
            />
          </div>
        </div>
      </div>
      <div className="mt-3">
                <ActivityCard doctype="UOM" docname={UOMName.UOMName} />
            </div>
    </div>

  )
}

export default Tab1